module.exports = __webpack_public_path__ + "static/media/number-yellow-6.1a3d4150.png";